export default function meme (context, args, flags) {
  const memes = ['homophobia', 'princesshappy', 'package', 'ohhi', 'highschool', 'gradient', 'binanry', 'brain']

  if (args.length > 0) {
    if (args[0] === 'show') {
      context.$parent.memes.push(args[1])
      return ''
    } else if (args[0] === 'random') {
      context.$parent.memes.push(memes[Math.floor(Math.random() * memes.length)])
      return ''
    } else if (args[0] === 'share') {
      const url = `${window.location.href}?meme=${args[1]}`
      return `<a href="${url}" target="_blank">${url}</a> <br /> click <u onclick="navigator.clipboard.writeText('${url}')" style="color: lightgrey">this</u> to copy url`
    }
  }
  return `use <code>random</code> for a random meme or use <code>show</code> for one of the following: ${memes.join(', ')}. if you want to share a specific meme you can use the <code>share</code> parameter followed by the name of the meme.`
}



// WEBPACK FOOTER //
// ./src/natos/commands/meme.js